import React, { FC } from 'react';
import { isBrandOV } from '../../constants/main';
import { SOLBenefits } from './SOL';
import { ConfigurableBenefits } from './Configurable';
import { ICarOffer, ISOLCarOffer } from '../../interfaces/Car';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../../context/featureSwitchApp';

interface IBenefitsProps {
    offers: ICarOffer[] | ISOLCarOffer[];
    disableFocus?: boolean;
    benefitsRef?: React.Ref<HTMLDivElement>;
    isOpenable?: boolean;
}

export const Benefits: FC<IBenefitsProps> = ({ offers, disableFocus, isOpenable, benefitsRef, ...rest }) => {
    const isSOLEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_SOL_ENABLED);

    //TODO fix type predicate dont work in transpiled code at runtime !!!
    // const areSOLOffers = (offers: ISOLCarOffer[] | ICarOffer[]): offers is ISOLCarOffer[] => isSOLEnabled || isBrandOV;
    const areSOLOffers = isSOLEnabled || isBrandOV;

    return areSOLOffers ? (
        <SOLBenefits disableFocus={disableFocus} isOpenable={isOpenable} offers={offers} {...rest} />
    ) : (
        <ConfigurableBenefits disableFocus={disableFocus} isOpenable={isOpenable} offers={offers} {...rest} />
    );
};
Benefits.displayName = 'Benefits';
